import { render, staticRenderFns } from "./MemberTabs.vue?vue&type=template&id=d35fc012"
import script from "./MemberTabs.vue?vue&type=script&lang=js"
export * from "./MemberTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports